<template>
  <div>
    <div class="reviews">
      <div class="review" v-for="(review, index) in orderedList" :key="index">
        <p class="title">{{ getMonth(review.date)}} {{ getYear(review.date) }}: {{ review.title }}</p>
        <p class="description">{{ review.text }}</p>
        <span class="rating">{{ review.note }}/5</span>
      </div>
    </div>
    <p class="info" v-html="$t('reviews.info')"></p>
 </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Reviews',
  mounted () {
    this.$store.dispatch('reviews/getAll')
  },
  computed: {
    ...mapState({
      list: state => state.reviews.list
    }),
    orderedList() {
      const list = JSON.parse(JSON.stringify(this.list))
      return list.sort(function(a,b){
        return new Date(b.date) - new Date(a.date);
      });
    }
  },
  methods: {
    getMonth(date) {
      const dateJS = new Date(date)
      const locale = this.$i18n.locale
      const month = dateJS.toLocaleString(locale, { month: "long" });
      return month
    },
    getYear(date) {
      const dateJS = new Date(date)
      return dateJS.getFullYear()
    }
  }
}
</script>


<style lang="scss" scoped>
  @import '../index.scss';
  .info {
    color: $light-blue;
    a {
      color: $light-blue;
    }
  }
  .reviews {
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    //   display: flex; 
    // flex-direction: column; 
    // flex-wrap: wrap;
    // // height: 100vw;
    // // max-width: 100vw;
    // max-height: 3000px;
    font-size: 0;
    .review {
      width: calc(50% - 20px);
      box-sizing: border-box;
      padding: 0 20px;
      text-align: left; 
      position: relative;
      padding-bottom: 10px;
      float:right;
      .title {
        text-align: left;
        font-size: 15px;
        // font-weight: bold;
        color: $light-blue;
        margin: 0;
        text-transform: capitalize;
      }
      .description {
        font-size: 14px;
        margin-top: 8px;
      }
      .rating {
        position: absolute;
        right: 10px;
        top: 0;
        color: white;
        background-color: #FFB600;
        text-align: center;
        padding: 0 5px;
        height: 20px;
        border-radius: 10px;
        line-height: 20px;
        font-size: 11px;
      }
      .separator {
        height: 1px;
        background-color: lightgray;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 70%;
        box-sizing: border-box;
        margin: auto;
      }
      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }
</style>